import React from "react";

function ProductCardsDispatch({ product }) {
  const { name, price, quantity, image, upc, substituteOrRefund } = product;

  return (
    <div className="flex gap-2 border border-lightborder p-1 rounded-sm">
      {/* Image */}
      <div className="flex-shrink-0">
        <img
          src={image}
          alt="product"
          className="object-contain max-w-[64px] max-h-[64px] rounded-sm"
        />
      </div>

      {/* Details */}
      <div className="flex-1 flex flex-col justify-between text-sm">
        <p className="font-medium wrap">{name}</p>
        {upc && <p className="text-xs text-gray-500">UPC: {upc}</p>}
        <div className="flex flex-wrap gap-2 mt-1">
          <span className="text-xs text-gray-600">Qty: {quantity}</span>
          <span className="font-semibold">${price}</span>
          {substituteOrRefund && (
            <span className="text-xs uppercase">{substituteOrRefund}</span>
          )}
        </div>
      </div>
    </div>
  );
}

export default ProductCardsDispatch;
